import humanizeString from 'humanize-string'

import { PaymentNotes } from '@avantstay/arriere-clients/dist/arriereBackoffice'

export enum AuditPaymentStatus {
  canceled = 'CANCELED',
  complete = 'COMPLETE',
  followUp = 'FOLLOW_UP',
  toDo = 'TO_DO',
  unassigned = 'UNASSIGNED',
}

export const auditPaymentLabel: { [key: string]: string } = Object.keys(AuditPaymentStatus).reduce(
  (acc, status) => {
    acc[status] = humanizeString(status)
    return acc
  },
  {} as { [key: string]: string },
)

export const auditPaymentNoteLabel: { [key: string]: string } = Object.keys(PaymentNotes).reduce(
  (acc, status) => {
    const shouldHumanize = [PaymentNotes.wire, PaymentNotes.unassigned]
    acc[status] = shouldHumanize.includes(status.toUpperCase() as PaymentNotes)
      ? humanizeString(status)
      : status.toUpperCase()
    return acc
  },
  {} as { [key: string]: string },
)
